import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-huanjing",
  "use": "icon-huanjing-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-huanjing\"><path d=\"M512 960a224 224 0 0 1-160-380.48V224a160 160 0 0 1 320 0v355.52A224 224 0 0 1 512 960z m0-832a96 96 0 0 0-96 96v369.28a32 32 0 0 1-10.56 23.68 160 160 0 1 0 213.12 0 32 32 0 0 1-10.56-23.68V224a96 96 0 0 0-96-96z\" fill=\"#4A8BFE\" /><path d=\"M512 736m-64 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0Z\" fill=\"#4A8BFE\" /><path d=\"M512 832a96 96 0 1 1 96-96 96 96 0 0 1-96 96z m0-128a32 32 0 1 0 32 32 32 32 0 0 0-32-32zM512 544h-96a32 32 0 0 1 0-64h96a32 32 0 0 1 0 64zM512 288h-96a32 32 0 0 1 0-64h96a32 32 0 0 1 0 64zM512 416h-96a32 32 0 0 1 0-64h96a32 32 0 0 1 0 64z\" fill=\"#4A8BFE\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/huanjing.svg
// module id = 55YS
// module chunks = 77